<template>

    <h1 class='title white f2 pl4'>{{title}}</h1>

</template>

<script>

export default {

    props:['title']
}

</script>
